<template>
  <paginate
    :page-count="props.totalPages"
    :click-handler="props.clickHandler"
    :prev-text="prevIcon"
    :next-text="nextIcon"
    :container-class="'pagination'"
  ></paginate>
</template>

<script setup>
import Paginate from "vuejs-paginate-next";

const prevIcon = '<span class="fal fa-arrow-left"></span>'
const nextIcon = '<span class="fal fa-arrow-right"></span>'
const props = defineProps({
  clickHandler: {
    type: Function,
    required: true
  },
  totalPages: {
    type: Number,
    required: true
  }
})
</script>